module.exports = __webpack_public_path__ + "img/1502050948.9f92fcc9.jpg";